import React from 'react';

import { PageTitle } from '../../components';
import { Menu } from '../../sections';



const MenuPage = () => {

  return (
    <>
        <PageTitle title={'our menu'} page={'menu'} />
        <Menu />
    </>
  )
}

export default MenuPage;